<template>
  <div>
    <header-bar :active="1"></header-bar>
    <div
      class="videomask"
      v-if="videoState == true"
      @click="masksCloseFun"
    ></div>
    <div class="videomasks" v-if="videoState == true">
      <video
        src="https://static4.coolbrainscience.cn/255dde0c27b842078f04de05912ad81b.mp4"
        controls="controls"
        autoplay
        width="100%"
      >
        当前浏览器不支持 video直接播放。
      </video>
    </div>
    <div class="bg" id="working_principle">
      <div class="image01">
        <!-- <img
          src="https://static4.coolbrainscience.cn/05aa88fab847408abbe9724de260695e.mp4"
          alt=""
        /> -->
        <video
          ref="videoElement"
          playsinline
          muted
          autoplay
          loop
          src="https://static4.coolbrainscience.cn/05aa88fab847408abbe9724de260695e.mp4"
        ></video>
      </div>
      <div class="bg_content">
        <div class="t1">功效原理</div>
        <div class="t2">
          PanBrain般意精力舱通过深层脑刺激技术重启大脑可塑性，打通神经元极化通道，通过重建大脑内<br />稳态平衡，达到提升精力，睡眠的持久作用。
        </div>
      </div>
    </div>
    <div class="part_1">
      <div class="part_1_left">
        <img
          src="https://static4.coolbrainscience.cn/5004121f2b004ceb90dc3952c9796636.png"
          alt=""
        />
      </div>
      <div class="part_1_right">
        <div class="part_1_content1 t3">
          般意精力舱的核心技术叫做经颅电刺激，精力舱上的两个干预模块会发出作用深度非常深的电流，到达大脑<br />额叶左右两边，以弧形的方式活化到整个大脑额叶的脑细胞，第一时间改变大脑神经元的膜电位，从而让神<br />经元可以在接下来的几个小时到几天更容易被激活，大脑额叶的神经连接“电线”不断被强化；在行为层面<br />上，就是让使用者更容易完成接下来做的事，无论这件事是学习、工作、运动，或者睡觉。<br /><br />
          通过坚持使用过般意精力舱，可以持续促进额叶神经网络的活化和升级，在额叶神经网络功能变强后，大脑<br />神经细胞电信号和神经递质（包括血清素、多巴胺、内啡肽、去甲肾上腺素、乙酰胆碱等等）的传递会变得<br />更顺利和快速，帮助不同人包括记忆、专注力、、、拖延、多梦、脑力衰退、精力下降等<br />脑功能问题。
        </div>
        <div class="part_1_content2">
          <div class="part_1_left1">
            <div class="t3">认知版参考周期</div>
            <div class="table-container">
              <div class="table-row">
                <div class="table-column t3">的方面</div>
                <div class="table-column t3">周期</div>
              </div>
              <div class="table-row">
                <div class="table-column t3">专注力提升</div>
                <div class="table-column t3">3-6周</div>
              </div>
              <div class="table-row">
                <div class="table-column t3">记忆力提升</div>
                <div class="table-column t3">2-3个月</div>
              </div>
              <div class="table-row">
                <div class="table-column t3">执行力提升</div>
                <div class="table-column t3">3-6周</div>
              </div>
              <div class="table-row">
                <div class="table-column t3">综合流体智力提升</div>
                <div class="table-column t3">3-6个月</div>
              </div>
            </div>
            <div class="t4">*个体大脑差异度很大，起效时间与效果因人而异。</div>
          </div>
          <div class="part_1_right1">
            <div class="t3">能量版参考周期</div>
            <div class="table-container">
              <div class="table-row">
                <div class="table-column t3">的方面</div>
                <div class="table-column t3">周期</div>
              </div>
              <div class="table-row">
                <div class="table-column t3">执行力和专注力</div>
                <div class="table-column t3">1周-1个月</div>
              </div>
              <div class="table-row">
                <div class="table-column t3">精力提升</div>
                <div class="table-column t3">2-3周</div>
              </div>
              <div class="table-row">
                <div class="table-column t3">emo内耗</div>
                <div class="table-column t3">3-6周</div>
              </div>
              <div class="table-row">
                <div class="table-column t3">情绪能量提升</div>
                <div class="table-column t3">4-8周</div>
              </div>
              <div class="table-row">
                <div class="table-column t3">睡眠</div>
                <div class="table-column t3">3周-3个月</div>
              </div>
              <div class="table-row">
                <div class="table-column t3">恐惧</div>
                <div class="table-column t3">4-8周</div>
              </div>
              <div class="table-row">
                <div class="table-column t3">低落情绪提升</div>
                <div class="table-column t3">1-6个月</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part_2">
      <img
        src="https://static4.coolbrainscience.cn/230817571b4c4bbf84d349744d2746f3.png"
        alt=""
      />
      <div class="part_2_content">
        <div class="t1">Technology & Papers</div>
        <div class="t2">技术特点与学术论文</div>
        <div class="line"></div>
        <div class="t3">
          使用PanBrain般意精力舱，每天仅需15分钟，给大脑做个深度重启
        </div>
      </div>
    </div>
    <div class="part_3">
      <div class="part_3_content1">
        <img
          src="https://static4.coolbrainscience.cn/8b29523c4a114c8fbd104260ab56fb19.png"
          alt=""
        />
        <div class="t1">精准脑电波检测</div>
      </div>
      <div class="line"></div>
      <div class="part_3_content2">
        <img
          src="https://static4.coolbrainscience.cn/68ad5287c61a4e4e803f16eef1cb9a52.png"
          alt=""
        />
        <div class="t1">个性化脑网络升级</div>
      </div>
      <div class="line"></div>
      <div class="part_3_content3">
        <img
          src="https://static4.coolbrainscience.cn/23fc24d6e0cf4f47ad25946471807a71.png"
          alt=""
        />
        <div class="t1">人体工学设计</div>
      </div>
      <div class="line"></div>
      <div class="part_3_content4">
        <img
          src="https://static4.coolbrainscience.cn/2bf60e9b14cf4484bb6148488a8a7349.png"
          alt=""
        />
        <div class="t1">多通道神经调控技术</div>
      </div>
    </div>
    <div class="part_4">
      <div class="part_4_content1">
        <div class="part_4_left">
          <div class="part_4_content11">
            <div class="content">
              <div class="t1">增强学习能力和专注力</div>
              <div class="t2">
                PanBrain精力舱基于深层电刺激技术打开神经元极化通道，定向重启大脑神经可塑性(Lukas
                Frase et al., 2021)。基于赫布原则（hebb’s principle）,
                共同放电的神经元长在一起，panbrain精力舱可以让大脑额叶神经网络在干预后的几小时到几天持续定向加强，经颅电刺激还可以促进神经元产生神经生长因子（Fritsch
                et al.,
                2010），长期使用可以促使成年人大脑二次发育，快速提升额叶所支持的学习能力和专注能力。
              </div>
              <img
                src="https://static4.coolbrainscience.cn/1d58162376394c8083e41619a9c4ac10.png"
                alt=""
              />
            </div>
          </div>
          <div class="part_4_content12">
            <div class="content">
              <div class="t1">提升大脑血氧供给</div>
              <div class="t2">
                即时提升大脑血氧供给，保护神经元，避免神经元因缺氧而出现功能低下，甚至受损。可以抵抗因高原反应、长时间脑力劳动或喝酒引起的额叶缺氧反应（Mathieu
                Figeys et al., 2021)。
              </div>
              <img
                src="https://static4.coolbrainscience.cn/16288bdd6a454870a264407d22e2e5a1.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="part_4_right">
          <div class="part_4_content13">
            <div class="content">
              <div class="t1">快速提升精力水平，重建大脑的内部稳定平衡状态</div>
              <div class="t2">
                PanBrain精力舱提供的经颅电刺激可以迅速代谢掉大脑神经元之间的疲劳副产物谷氨酸，帮助大脑快速恢复精力饱满的状态，无论何时，以饱满的精神状态迎接脑力挑战。（Heimrath
                K et al., 2020)
              </div>
              <img
                src="https://static4.coolbrainscience.cn/ef9341b61d6040afbe066dcf9faa3dbe.png"
                alt=""
              />
            </div>
          </div>
          <div class="part_4_content14">
            <div class="content">
              <div class="t1">提升睡眠质量，保持大脑年轻态</div>
              <div class="t2">
                大脑自我修复主要依赖深度睡眠，脑科学研究发现，成年人每晚的深度睡眠时间为1.5-2小时，深度睡眠不足会导致大脑内部生物废料积累和加速衰老
                (Zsofia zavecz et al.,
                2023)。panbrain精力舱通过提升神经可塑性，让内部神经同步性变得更好，从而促使大脑更容易进入和维持深度睡眠状态，长期使用可以让大脑拥有更高效的作息节律，深度睡眠比例增加，白天大脑状态也更年轻有活力。
              </div>
              <img
                src="https://static4.coolbrainscience.cn/0b4389bc6fdd42c1830a74efc91590b4.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div class="part_4_content2" id="patent_certificate">
        <div class="t3">CERTIFICATE</div>
        <div class="t4">通过国内外 <br />多项技术认证</div>
        <div class="line"></div>
        <img
          src="https://static4.coolbrainscience.cn/71462533117943cea21dc2f0b2aaaa50.png"
          alt=""
        />
      </div>
      <div class="part_4_content3">
        <div class="t5">PATENTS</div>
        <div class="t6">荣获多项 <br />国家发明专利</div>
        <div class="line"></div>
        <img
          src="https://static4.coolbrainscience.cn/01357b9b690c409a86f2c9edd57af6fb.png"
          alt=""
        />
      </div>
      <div class="part_4_content4">
        <img @click="checkVideoFun()" src="../../assets/play.png" />
      </div>
    </div>
    <!--<div class="part_1" id="working_principle">
      <div class="title">工作原理，经颅直流电刺激（tDCS）</div>
      <ul style="margin-top: 4vw">
        <li>
          般意精力舱的原理，类似于被动锻炼大脑额叶，激发特定高级皮层的可塑性，帮助大脑达到更好的功能状态。
        </li>
        <li>
          在动物研究和人脑研究中发现，特定电流会经过电极头触达大脑皮层特定区域，在正极附近的大脑皮层神经元集群形成兴奋效应，在负极附近的大脑皮层神经元集群形成抑制效应，兴奋和抑制效应通过改变神经元细胞膜电位，导致神经元的去极化和超极化，从而造成生物物理层面的改变。
        </li>
        <li>
          此外，电流还会改变作用区域附近的脑血流量，有效增加基于脑源性神经营养因子的神经突触可塑性，增强神经网络连接，这种改变效应会在干预结束后数小时到数天持续影响大脑皮层功能和结构。在人类症患者的临床研究中发现，技术或可提升神经生长因子的水平，进而调控神经可塑性。
        </li>
      </ul>
      <img
        src="https://static4.coolbrainscience.cn/eefe64a6805c461c8b98b2a091d7a151.png"
      />
      <ul>
        <li>
          在以往研究中，左额叶被证明与积极情绪有关，右侧额叶被证明与消极情绪有关，症病人左侧额叶活跃程度下降，右侧额叶活跃程度过高。通过特定电流刺激小鼠或人的左侧额叶，可以减少消极情绪，增强积极情绪，增强额叶对皮层下情绪核团的能力。
        </li>
      </ul>
    </div>
    <div class="part_2">
      <div class="part_2_content">
        <div class="t1">智能化穿戴，你的高科技大脑助手</div>
        <div class="t2">
          人体工学的设计，高精度的工艺，领先的自研算法，专业的报告分析
        </div>
      </div>
    </div>
    <div class="part_3" id="principles_of_technology">
      <div class="part_3_content">
        <div class="part_3_title1">干预刺激</div>
        <div class="part_3_title2">电极触头+高精度控制电路</div>
        <div class="part_3_title3">
          采用人体工学导电硅胶触头和进口高精度控制电路材料
          ，可以实现非常准确的电流精度。
        </div>
      </div>
    </div>
    <div class="part_4">
      <div class="part_4_content">
        <div class="part_4_title1">脑电检测</div>
        <div class="part_4_title2">金属电极片</div>
      </div>
      <div class="part_4_title3">
        采用核心采集模组配合自研算法技术。通过前额特定区域的脑电波采集，经过特定算法的去噪滤波和脑电频率解析，从而展示出大脑当前的专注状态以及精力程度。
      </div>
    </div>
    <div class="part_5">
      <div class="part_5_content">
        <div class="part_5_title1">智能佩戴检测</div>
        <div class="part_5_title2">智能硬件+自研算法</div>
        <div class="part_5_title3">
          产品自带智能佩戴检测功能，在用户佩戴不佳时，会有语音提示用户校准佩戴。
        </div>
      </div>
    </div>
    <div class="part_6" id="ergonomically_designed">
      <div class="part_6_content">
        <div class="part_6_title1">人体工学设计</div>
        <div class="part_6_title2">记忆海绵+蛋白皮内衬+可绑带+防滑垫</div>
        <div class="part_6_title3">
          弹性设计，适配多种头围尺寸，贴合人体头部弧度，拥有头部太空舱般的舒适体验，于此同时又能保证佩戴的稳定性。
        </div>
      </div>
    </div>
    <div class="part_7">
      <div class="part_7_content">
        <div class="part_7_title1">高科技超纤材料</div>
        <div class="part_7_title2">超细纤维+智能织法</div>
        <div class="part_7_title3">
          外壳采用高科技超纤维材料，触感轻柔舒适，抗菌耐磨易清洁。
        </div>
      </div>
    </div>
    <div class="part_8">
      <div class="part_8_content">
        <div class="part_8_title1">智能互联掌握大脑变化</div>
        <div class="part_8_title2">蓝牙+应用程序</div>
        <div class="part_8_title3">
          通过产品内置的蓝牙能轻松实现与手机的智能互联，通过手机应用 (般意)
          对产品进行设置和操作，实现产品与消费者的智能互动。并且获取大脑活跃度指标，使用前后状态反馈和个性化用脑建议。
        </div>
      </div>
    </div>
    <div class="part_9">
      <div class="part_9_content">
        <div class="part_9_left">
          <div class="part_9_title1">产品佩戴及使用说明</div>
          <div class="part_9_title2">
            包含内容有首次使用前的注意事项，使用前的注意事项，如何正确佩戴，如何正常使用，用后清洁及保养，如何充电和如何下载APP。
          </div>
          <button type="button" @click="$router.push('/video')">
            立即观看
          </button>
        </div>
        <div class="part_9_right">
          <img
            src="../../assets/Video-Medium.png"
            @click="$router.push('/video')"
          />
        </div>
      </div>
    </div>-->
    <!-- <div class="tab2top">
      <div class="tab2text">
        我们的大脑并非一成不变，它就像我们的肌肉一样，通过针对性的训练，特定脑区可以变得更强壮，控制力更强，反应更快，更聪明、更健康。威斯康星大学的科学家通过研究大脑“神经可塑性”，发现冥想可以有效地增加某些脑区的“灰质厚度”。
      </div>
      <div class="tab2text">
        很多神经科学家都将冥想作为主要的脑“增强剂”，它具有提高情绪管理和认知各个方面能力的潜力
      </div>
    </div> -->
    <!-- <div class="tab2Content">
      <img class="tab2Img" :src="require('./../../assets/14.png')" />
      <div class="tab2cont1">
        <div>其实，一个人并不需要花几年的时间来接受密集的冥想训练。</div>
        <div>
          有研究表明，<strong>每天仅需冥想15分钟，即可看到大脑皮层明显的变化</strong>
        </div>
        <div>
          。你只需要练习短短的<strong>4 节冥想课，就可以明显提高工作记忆能力；</strong>
        </div>
        <div><strong>5 节冥想课就可以提升你的情绪； </strong></div>
        <div>
          <strong>而 3 到 6 个月的冥想训练，可以提高你的综合认知力。</strong>
        </div>
      </div>
      <div class="tab2cont2">
        正确的冥想练习方法很重要，有比较严重的情绪问题、精神障碍的人，只有在专业人士的指导下才能从正念冥想中受益。如果在没有支持的情况下进行冥想，可能会因为冥想产生更多的问题。正确的正念导师拥有强大的正向稳定气场，他会用周围的“磁场”感染你，用他的定力带你感受宁静深邃，帮助你练习和学会掌握精细的“心灵动作”。在正念导师的带领下，你能复刻这份宁静和强大。
      </div>
      <div class="tab2button" @click='$router.push("/sleep")'>导师信息</div>
    </div> -->
    <footer-info></footer-info>
  </div>
</template>
<script>
import footerInfo from "@/components/common/FooterInfo";
import headerBar from "@/components/common/HeaderBar";
export default {
  data() {
    return {
      videoState: false,
    };
  },
  components: {
    footerInfo,
    headerBar,
  },
  created() {
    this.$nextTick(() => {
      this.toLocal();
    });
  },
  mounted: function () {
    const video = this.$refs.videoElement;

    // 监听视频结束事件
    video.addEventListener("ended", () => {
      // 手动重置视频到开始位置
      video.currentTime = 0;
      // 有时候需要手动触发播放以确保循环播放
      video.play();
    });
    // axios
    //   .get(
    //     "https://www.easy-mock.com/mock/5a67ef8cbdf9f5437bb4979a/Data/homedata"
    //   )
    //   .then(response => {
    //     this.major = response.data.major;
    //     this.ads = response.data.ads;
    //   })
    //   .catch(error => {
    //     alert("网络错误不能访问");
    //   });
  },
  methods: {
    toLocal() {
      let Id = window.sessionStorage.getItem("toId");
      if (Id) {
        let toElement = document.getElementById(Id);
        toElement.scrollIntoView();
      }
    },
    checkVideoFun() {
      this.videoState = true;
    },
    masksCloseFun() {
      this.videoState = false;
    },
  },
  // destroyed() {
  //   window.sessionStorage.setItem('toId', '')
  // },
};
</script>
<!-- <style src="@/components/common/mood.css" scoped></style> -->
<style scoped>
.part_4_content3 {
  text-align: center;
}

.part_4_content3 .t5 {
  background: linear-gradient(349.7601927361714deg, #162f60 0%, #6b7cb5 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 1.458vw;
  letter-spacing: 0.625vw;
  margin: 2.08vw 0 1.25vw 0;
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
}

.part_4_content3 .t6 {
  background: linear-gradient(349.7601927361714deg, #162f60 0%, #6b7cb5 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 3.125vw;
  letter-spacing: 0.1vw;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
}

.part_4_content3 .line {
  margin: 1.25vw auto 2.08vw auto;
  width: 4.8958vw;
  height: 0.2083vw;
  border-radius: 2.5vw;
  background: linear-gradient(96deg, #819feb 0%, rgba(194, 204, 225, 0) 100%);
}

.part_4_content3 img {
  width: 73.4375vw;
  height: 58.75vw;
}

.part_4_content4 {
  width: 100vw;
  height: 56.25vw;
  background: url(../../assets/tech12.png) no-repeat;
  background-size: 100% 100%;
  text-align: center;
  line-height: 56.25vw;
  margin-top: 4.5vw;
}

.part_4_content4 img {
  width: 5.2vw;
  height: 5.2vw;
  vertical-align: middle;
}
* {
  font-family: "fontnormal";
}

.videomask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  background-color: #000;
  opacity: 0.6;
}

.videomasks {
  width: 80%;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

.bg {
  width: 100vw;
  height: 56.25vw;
  /* background: url(../../assets/tech14.gif) no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center; */
  position: relative;
}

.bg video {
  width: 100vw;
  height: 56.25vw;
}

/* .image01 {
  width: 100vw;
  position: relative;
} */

.bg_content {
  position: absolute;
  width: 73.4375vw;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.bg_content .t1 {
  text-align: center;
  color: #ffffff;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 3.125vw;
  letter-spacing: 0.1vw;
}

.bg_content .t2 {
  color: #ffffff;
  font-size: 1.67vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  margin-top: 2.5vw;
  text-align: justify;
}

.part_1 {
  background: #000000;
  width: 100vw;
  padding: 2.7vw 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.part_1_left img {
  width: 27.656vw;
  height: 36.823vw;
}

.part_1_right {
  margin-left: 1.67vw;
}

.part_1_right .t3 {
  color: #ffffff;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.94vw;
}

.part_1_right .t4 {
  color: #ffffff;
  font-size: 0.73vw;
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
  margin-top: 2.76vw;
}

.part_1_right .part_1_content2 {
  text-align: center;
  overflow: hidden;
  margin-top: 0.78vw;
}

.part_1_content2 .part_1_left1 {
  width: 16.875vw;
  float: left;
}

.part_1_content2 .part_1_right1 {
  width: 16.875vw;
  float: right;
}

.table-container {
  display: flex;
  flex-direction: column;
  margin-top: 1.3vw;
}

.table-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.42vw;
}

.table-column {
  flex: 1;
}

.part_2 {
  position: relative;
  width: 100vw;
  height: 20.83vw;
}

.part_2 img {
  width: 100vw;
  height: 20.83vw;
}

.part_2_content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  white-space: nowrap;
}

.part_2_content .t1 {
  text-transform: uppercase;
  color: #ffffff;
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
  font-size: 1.458vw;
  letter-spacing: 0.625vw;
}

.part_2_content .t2 {
  color: #ffffff;
  font-size: 3.125vw;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  letter-spacing: 0.1vw;
  margin-top: 1.25vw;
}

.part_2_content .line {
  background: #ffffff;
  border-radius: 2.5vw;
  width: 4.9vw;
  height: 0.21vw;
  margin: 1.25vw auto;
}

.part_2_content .t3 {
  color: #ffffff;
  font-size: 1.67vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
}

.part_3 {
  width: 100vw;
  height: 13.96vw;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.part_3 img {
  width: 4.17vw;
  height: 4.17vw;
}

.part_3 .line {
  width: 0;
  height: 4.1vw;
  border: 0.026vw solid #9b9b9b;
  margin: 0 6.6vw;
}

.part_3 .t1 {
  color: #333333;
  font-size: 0.94vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
}

.part_4 {
  width: 100vw;
  background: #ffffff;
}

.part_4 .t1 {
  color: #333333;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.67vw;
}

.part_4 .t2 {
  color: #333333;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.94vw;
  margin: 1.25vw 0;
}

.part_4 .content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 31.93vw;
  text-align: justify;
}

.part_4_content1 {
  display: flex;
  justify-content: center;
}

.part_4_left {
  margin-right: 1.25vw;
}

.part_4_left img {
  width: 31.93vw;
  height: 14.22vw;
}

.part_4_content13 img {
  width: 31.93vw;
  height: 13.125vw;
}

.part_4_content14 img {
  width: 31.93vw;
  height: 12.396vw;
}

.part_4_content11 {
  width: 36.1vw;
  height: 29.6vw;
  background: #f3f4fe;
  position: relative;
}

.part_4_content12 {
  width: 36.1vw;
  height: 25.3vw;
  margin-top: 1.25vw;
  background: #f3f4fe;
  position: relative;
}

.part_4_content13 {
  width: 36.1vw;
  height: 27vw;
  position: relative;
  background: #f3f4fe;
}

.part_4_content14 {
  width: 36.1vw;
  height: 27.9vw;
  position: relative;
  background: #f3f4fe;
  margin-top: 1.25vw;
}

.part_4_content2 {
  text-align: center;
}

.part_4_content2 .t3 {
  margin: 4.27vw 0 1.25vw 0;
  background: linear-gradient(349.7601927361714deg, #162f60 0%, #6b7cb5 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 1.46vw;
  letter-spacing: 0.625vw;
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
}

.part_4_content2 .t4 {
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 3.125vw;
  letter-spacing: 0.1vw;
  background: linear-gradient(349.7601927361714deg, #162f60 0%, #6b7cb5 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.part_4_content2 .line {
  background: linear-gradient(96deg, #819feb 0%, rgba(194, 204, 225, 0) 100%);
  border-radius: 2.5vw;
  width: 4.8958vw;
  height: 0.21vw;
  margin: 1.25vw auto 2.08vw auto;
}

.part_4_content2 img {
  width: 73.4375vw;
  height: 41.6667vw;
}

/*.part_1 {
  padding: 3.9vw 13.3vw 3.1vw 13.3vw;
}

.part_1 .title {
  text-align: center;
  color: #333333;
  font-size: 2.2vw;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
}

ul {
  margin: 0;
  padding: 0;
}

ul > li {
  list-style-type: none;
  color: #333333;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
  font-size: 0.9vw;
}

.part_1 img {
  width: 73.4vw;
  height: 22.3vw;
  margin: 1.46vw 0;
}

.part_2 {
  width: 100vw;
  height: 11.9vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #888ef9;
  text-align: center;
}

.part_2_content .t1 {
  font-size: 2.2vw;
  color: #ffffff;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
}

.part_2_content .t2 {
  font-size: 0.9vw;
  color: #ffffff;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
  margin-top: 0.6vw;
}

.part_3_title1,
.part_4_title1,
.part_5_title1,
.part_6_title1,
.part_7_title1,
.part_8_title1 {
  font-size: 2.19vw;
  color: #333333;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
}

.part_3_title2,
.part_4_title2,
.part_5_title2,
.part_6_title2,
.part_7_title2,
.part_8_title2 {
  color: #9b9b9b;
  font-size: 1.67vw;
  margin-top: 1.56vw;
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
}

.part_3_title3,
.part_5_title3,
.part_6_title3,
.part_7_title3,
.part_8_title3 {
  margin-top: 0.83vw;
  font-size: 0.9vw;
  color: #333333;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
}

.part_3,
.part_4,
.part_5,
.part_6,
.part_7,
.part_8 {
  width: 100vw;
  height: 31.25vw;
  position: relative;
}

.part_3 {
  background: url(../../assets/3.png) no-repeat;
  background-size: 100% 100%;
}

.part_4 {
  background: url(../../assets/4.png) no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}

.part_5 {
  background: url(../../assets/5.png) no-repeat;
  background-size: 100% 100%;
}

.part_6 {
  background: url(../../assets/6.png) no-repeat;
  background-size: 100% 100%;
}

.part_7 {
  background: url(../../assets/7.png) no-repeat;
  background-size: 100% 100%;
}

.part_8 {
  background: url(../../assets/8.png) no-repeat;
  background-size: 100% 100%;
}

.part_3_content,
.part_8_content {
  width: 28.6vw;
  position: absolute;
  top: 6.56vw;
  right: 11vw;
}

.part_6_content {
  position: absolute;
  top: 6.56vw;
  right: 11vw;
  width: 31.25vw;
}

.part_4_content {
  float: left;
  margin-top: 4.84vw;
  margin-left: 13vw;
}

.part_5_content,
.part_7_content {
  position: absolute;
  top: 8.59vw;
  left: 13vw;
  width: 28.6vw;
}

.part_4_title3 {
  width: 55.7vw;
  font-size: 0.9vw;
  color: #333333;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
  float: left;
  margin-top: 5.57vw;
  margin-left: 4vw;
}

.part_9 {
  width: 100vw;
  height: 39vw;
  background: #f3f4fe;
}

.part_9_content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
}

.part_9_left {
  width: 28vw;
  position: absolute;
  left: 13.02vw;
}

.part_9_title1 {
  color: #333333;
  font-size: 2.2vw;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  margin-bottom: 1.56vw;
}

.part_9_title2 {
  font-size: 0.9vw;
  color: #9b9b9b;
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
  margin-bottom: 2.92vw;
}

.part_9_left button {
  width: 10vw;
  height: 3vw;
  background: #888ef9;
  border-radius: 0.3vw;
  color: #ffffff;
  font-size: 0.9vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  border: none;
}

.part_9_right {
  width: 36.46vw;
  height: 23.96vw;
  position: absolute;
  right: 13.02vw;
}

.part_9_right img {
  width: 100%;
  height: 100%;
}*/
</style>
<!--<style scoped>
  @font-face {

    src: url('../../font/SourceHanSansSC-Normal.otf')format('opentype');
  }

  @font-face {

    src: url('../../font/SourceHanSansSC-Regular.otf')format('opentype');
  }

  .bg img {
    width: 100vw;
    height: 56.25vw;
  }

  .tab2top {
    width: 100%;
    height: 20.4vw;
    background: url("./../../assets/13.png") no-repeat;
    background-size: contain;
    padding: 13.9vw 49vw;
    padding-right: 8.4vw;
  }

  .tab2text {
    width: 42.7vw;
    font-size: 1.4vw;

    font-weight: 400;
    color: #000000;
    margin-bottom: 2.8vw;
  }

  .tab2Content {
    text-align: center;
  }

  .tab2Img {
    width: 82.3vw;
    height: 18vw;
    margin: 0 auto;
    margin-top: -12.2vw;
  }

  .tab2cont1 {
    margin-top: 2.3vw;
    margin-bottom: 2.8vw;
    font-size: 1.4vw;

    font-weight: 400;
    color: #000000;
  }

  .tab2cont2 {
    font-size: 1.4vw;
    margin: 0 8.5vw;
    margin-bottom: 3.6vw;

    font-weight: 400;
    color: #000000;
    text-align: left;
  }

  .tab2button {
    cursor: pointer;
    width: 8.1vw;
    height: 2.7vw;
    background: #233923;
    border-radius: 2.2vw;
    text-align: center;
    margin: 0 auto;
    font-size: 1.2vw;

    font-weight: 400;
    color: #ffffff;
    line-height: 2.7vw;
    margin-bottom: 6.1vw;
  }
</style> -->



// WEBPACK FOOTER //
// src/components/pages/Mood.vue